// src/services/settings.js
import axios from "axios";
import { getToken } from "../Utils/Common";
import token_valid from "./TokenValid";// or wherever you export this

const API = process.env.REACT_APP_API_URL;


export const getSettingsByCode = async (code) => {
  let token_valid_result = await token_valid();
  if (!token_valid_result) return "Something went wrong...";

  const token = getToken();

  return axios
    .get(`${API}/api/settings/${encodeURIComponent(code)}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => response.data) // returns Settings object
    .catch((error) => {
      console.log("get settings error", error);
      return "Something went wrong...";
    });
};


export const saveSettingsReplace = async (code, data) => {
  let token_valid_result = await token_valid();
  if (!token_valid_result) return false;

  const token = getToken();

  return axios
    .post(
      `${API}/api/settings/save`,
      { code, data },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    )
    .then(() => true)
    .catch((error) => {
      console.log("save settings error", error);
      return false;
    });
};

/**
 * Shallow-merge (or create) keys into the settings for a code.
 */
export const mergeSettings = async (code, partial) => {
  let token_valid_result = await token_valid();
  if (!token_valid_result) return false;

  const token = getToken();

  return axios
    .patch(
      `${API}/api/settings/merge`,
      { code, data: partial },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    )
    .then(() => true)
    .catch((error) => {
      console.log("merge settings error", error);
      return false;
    });
};
